module.exports = require("@wildboar/x500/src/lib/modules/PasswordPolicy/PwdEncAlg.ta");